/*
 * Hides the about-us newsletter block for visitors who have already subscribed
 * Subscription state is shared across newsletter forms (welcome popup, about-us
 * block, etc.) via the same localStorage flag.
 *
 * Server-side suppression (logged-in customers who accept marketing) is handled
 * in the block's Liquid; this only covers the anonymous, browser-level case.
 */
(function () {
  // `window` has no index signature under checkJs, so cast to reach Shopify.
  var w = /** @type {any} */ (window);

  // Never hide in the theme editor — the merchant needs to see/edit the block.
  if (w.Shopify && w.Shopify.designMode) return;

  var SUBSCRIBED_KEY = "offside:newsletter:subscribed";
  // Shared trigger read by the newsletter-confirmation section.
  var CONFIRM_FLAG = "offside:newsletter:show-confirm";

  function isSubscribed() {
    try {
      return localStorage.getItem(SUBSCRIBED_KEY) === "1";
    } catch (e) {
      return false;
    }
  }

  function markSubscribed() {
    try {
      localStorage.setItem(SUBSCRIBED_KEY, "1");
    } catch (e) {
      /* ignore */
    }
  }

  function flagConfirmation() {
    try {
      sessionStorage.setItem(CONFIRM_FLAG, "1");
    } catch (e) {
      /* ignore */
    }
  }

  /** @param {HTMLFormElement} form */
  function bindOptionalNameSubmit(form) {
    form.addEventListener("submit", function () {
      var nameInput = form.querySelector("[data-newsletter-optional-name]");
      if (!(nameInput instanceof HTMLInputElement)) return;
      if (nameInput.value.trim() === "") return;

      nameInput.setAttribute("name", "contact[first_name]");
    });
  }

  // Success is read from Shopify's post-submit redirect
  // ("?customer_posted=true#<form-id>"), matching the hash to THIS form's id —
  // the same reliable approach the welcome popup uses.
  /** @param {Element} container */
  function justSubscribed(container) {
    var form = container.querySelector("form");
    var formId = form ? form.id : "";
    return (
      new URLSearchParams(window.location.search).get("customer_posted") ===
        "true" &&
      !!formId &&
      window.location.hash.slice(1) === formId
    );
  }

  /** @param {Element} container */
  function process(container) {
    if (!(container instanceof HTMLElement)) return;

    var form = container.querySelector("form");
    if (form instanceof HTMLFormElement) {
      bindOptionalNameSubmit(form);
    }

    if (justSubscribed(container)) {
      markSubscribed();
      flagConfirmation();

      var redirect = container.dataset.newsletterRedirect;
      if (redirect) {
        window.location.replace(redirect);
        return;
      }
      return;
    }

    if (isSubscribed()) {
      container.hidden = true;
    }
  }

  function run() {
    document.querySelectorAll("[data-newsletter-signup]").forEach(process);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", run);
  } else {
    run();
  }
})();
